import React, { useState, useEffect } from 'react';

const GreetingsModal = ({ show, onClose, gaonSrNo, onSubmit }) => {
  const [formData, setFormData] = useState({
    type: 'Birthday',
    name: '',
    message: '',
    image: null,
    messanger_name: '',
    messanger_mobile: '',
  });

  const [submitStatus, setSubmitStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [isEligible, setIsEligible] = useState(true);

  const [ip, setIp] = useState('');
  const [uniqueId, setUniqueId] = useState('');
  const [population, setPopulation] = useState(0);

  // Generate unique ID from UUID + IP
  const generateUniqueId = async () => {
    let uuid = localStorage.getItem('deviceUUID');
    if (!uuid) {
      uuid = crypto.randomUUID();
      localStorage.setItem('deviceUUID', uuid);
    }

    const ipData = await fetch('https://api.db-ip.com/v2/free/self').then(res => res.json());
    setIp(ipData.ipAddress);
    const shortIP = ipData.ipAddress.split('.').slice(0, 2).join('.');
    const unique = `${uuid}-${shortIP}`;
    setUniqueId(unique);
    return { uuid, shortIP, unique };
  };

  useEffect(() => {
    if (show) {
      generateUniqueId().then(({ unique }) => {
        fetch(`https://mazagaon.co.in/api/get-user-info.php?ip=${unique}&gaonSrNo=${gaonSrNo}`)
          .then(res => res.json())
          .then(data => {
            setPopulation(parseInt(data.total_population || 0));
            const lastSent = new Date(data.last_sent_date);
            const now = new Date();
            const diffDays = Math.floor((now - lastSent) / (1000 * 60 * 60 * 24));
            setIsEligible(diffDays > 7);
          })
          .catch(err => {
            console.error('User info fetch error:', err);
            setIsEligible(true); // fallback to allow
          });
      });
    }
  }, [show, gaonSrNo]);

  useEffect(() => {
    if (uniqueId) {
      setFormData(prev => ({
        ...prev,
        messanger_ip: uniqueId,
      }));
    }
  }, [uniqueId]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: files ? files[0] : value
    }));
  };

  const calculatePrice = () => {
    if (isEligible) return 0;
    const withImage = !!formData.image;
    if (population <= 2000) return withImage ? 29 : 19;
    if (population <= 5000) return withImage ? 49 : 29;
    return withImage ? 69 : 49;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('');

    const cost = calculatePrice();
    const payload = {
      ...formData,
      gaon_Sr_No: gaonSrNo,
      messanger_ip: uniqueId
    };

    if (cost > 0) {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = 'https://boostyourbusinessdigitally.in/getorder_mazagaon.php';

      const addField = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      };

      addField('basicvalue', cost);

      for (const key in payload) {
        if (payload[key] instanceof File) continue; // skip image
        addField(key, payload[key]);
      }

      document.body.appendChild(form);
      form.submit();
      return;
    }

    // Free case: directly submit
    await submitToBackend(payload);
  };

  const submitToBackend = async (payload) => {
    setLoading(true);
    const data = new FormData();

    for (const key in payload) {
      data.append(key, payload[key]);
    }

    if (formData.image) {
      data.append('image', formData.image);
    }

    try {
      const res = await fetch('https://mazagaon.co.in/api/submit_greetings.php', {
        method: 'POST',
        body: data,
      });

      const result = await res.text();
      if (res.ok) {
        alert('✅ तुमचा संदेश यशस्वीरित्या सबमिट झाला!');
        onSubmit({
          title: formData.name,
          description: formData.message,
          type: formData.type,
          image: formData.image ? URL.createObjectURL(formData.image) : null,
          contact: '',
          messanger_name: formData.messanger_name,
          date: new Date().toISOString(),
        });

        setFormData({
          type: 'Birthday',
          name: '',
          message: '',
          image: null,
          messanger_name: '',
          messanger_mobile: '',
        });

        onClose();
      } else {
        setSubmitStatus('❌ काहीतरी चूक झाली. पुन्हा प्रयत्न करा.');
      }
    } catch (err) {
      console.error(err);
      setSubmitStatus('❌ सर्व्हरशी संपर्क होऊ शकला नाही.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          {loading && (
            <div style={{
              position: 'absolute',
              top: 0, left: 0, right: 0, bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999,
            }}>
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Uploading...</span>
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="modal-header">
              <h5 className="modal-title">नवीन संदेश जोडा</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">संदेशाचा प्रकार</label>
                <select className="form-select" name="type" value={formData.type} onChange={handleChange}>
                  <option value="Birthday">वाढदिवस</option>
                  <option value="Greetings">शुभेच्छा</option>
                  <option value="Tribute">श्रद्धांजली</option>
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">यांच्यासाठी संदेश (नाव)</label>
                <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} required />
              </div>
              <div className="mb-3">
                <label className="form-label">संदेश :</label>
                <textarea className="form-control" name="message" rows="3" value={formData.message} onChange={handleChange} required></textarea>
              </div>
              <div className="mb-3">
                <label className="form-label">फोटो (ऐच्छिक)</label>
                <input type="file" className="form-control" name="image" accept="image/*" onChange={handleChange} />
              </div>
              <div className="mb-3">
                <label className="form-label">संदेश पाठविणाऱ्याचे नाव :</label>
                <input type="text" className="form-control" name="messanger_name" value={formData.messanger_name} onChange={handleChange} required />
              </div>
              <div className="mb-3">
                <label className="form-label">संदेश पाठविणाऱ्याचा मोबाईल नं. :</label>
                <input type="text" className="form-control" name="messanger_mobile" value={formData.messanger_mobile} onChange={handleChange} required />
              </div>

              <div className="mb-3">
                <label className="form-label">संदेश पाठविणाऱ्याचा इमेल आयडी :</label>
                <input type="text" className="form-control" name="messanger_email" value={formData.messanger_email} onChange={handleChange} required />
              </div>

              {!isEligible && (
                <div className="text-end text-danger fw-bold">
                  शुल्क लागू: ₹{calculatePrice()}
                </div>
              )}

              {submitStatus && <div className="alert alert-info mt-2">{submitStatus}</div>}
            </div>
            <div className="modal-footer">
              <button type="submit" className="btn btn-success">सबमिट करा</button>
              <button type="button" className="btn btn-secondary" onClick={onClose}>बंद करा</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GreetingsModal;
